import UserAssignedPatients from './UserAssignedPatients';
export default UserAssignedPatients;
